import APIUrl from "../../APIUrl";
import axios from "axios";
import Util from "../../util/Util";

export const GET_USER = "GET_USER";

export function getUserAction(user) {
  return { type: GET_USER, user: user };
}

export const getUser = function (callback) {
  return function (dispatch) {
    return axios
      .get(APIUrl.getUser)
      .then(function (response) {
        if (!response || !response.status)
          window.location.replace(
            Util.checkHttps(process.env.REACT_APP_LOGIN_URL),
          );

        dispatch(getUserAction(response.data));
        if (callback) callback();
      })
      .catch(function (err) {
        window.location.replace(
          Util.checkHttps(process.env.REACT_APP_LOGIN_URL),
        );
      });
  };
};

export const checkIfUsernameExists = function (
  username,
  existsCallback,
  noExistsCallback,
) {
  return function (dispatch) {
    return axios
      .get(APIUrl.checkIfUsernameExists + username)
      .then(function (response) {
        if (response && response.status === 200) {
          if (existsCallback) existsCallback();
        } else {
          if (noExistsCallback) noExistsCallback();
        }
      });
  };
};

export const updateUser = function (data, successCallback) {
  return function (dispatch) {
    return axios.post(APIUrl.updateUser, data).then(function (response) {
      dispatch(getUser());
      if (successCallback) successCallback();
    });
  };
};

export const addFavorite = function (data, successCallback) {
  // console.log("requete "+ data.updatedUser + " = "+data.updatedValue);
  return function (dispatch) {
    return axios.post(APIUrl.addFavorite, data).then(function (response) {
      dispatch(getUser());
      if (successCallback) successCallback();
    });
  };
};

export const deleteFavorite = function (data, successCallback) {
  // console.log("requetedelete "+ data.updatedUser + " = "+data.deletedValue);
  return function (dispatch) {
    return axios.post(APIUrl.deleteFavorite, data).then(function (response) {
      dispatch(getUser());
      if (successCallback) successCallback();
    });
  };
};

export const addFavoriteRental = function (data, successCallback) {
  return function (dispatch) {
    return axios.post(APIUrl.addFavoriteRental, data).then(function (response) {
      dispatch(getUser());
      if (successCallback) successCallback();
    });
  };
};

export const deleteFavoriteRental = function (data, successCallback) {
  return function (dispatch) {
    return axios
      .post(APIUrl.deleteFavoriteRental, data)
      .then(function (response) {
        dispatch(getUser());
        if (successCallback) successCallback();
      });
  };
};
